import { AutoComplete, ISelectType, useFetch, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useWatch } from "react-hook-form";
import { insurancePlanList } from "../../../../../../../services/insurancePlan.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const InsurancePlanExternalIdThen = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  const insuranceExternalIdThen = useWatch({
    control,
    name: "insuranceExternalIdThen",
  });

  const { sendRequest } = useFetch(insurancePlanList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const insuranceId = insuranceExternalIdThen?.id;

  const fetchOptions = useCallback(
    async (currentInsuranceId: typeof insuranceId, isStale: () => boolean) => {
      if (!currentInsuranceId) {
        if (!isStale()) setOptions([]);
        return;
      }

      const { data, success } = await sendRequest({
        insuranceIdentifier: currentInsuranceId,
      });
      if (data && success && !isStale()) {
        setOptions(
          (data ?? []).map((item) => ({
            id: item.identifier ?? "",
            name: item.name ?? "",
          })),
        );
      }
    },
    [sendRequest],
  );

  useEffect(() => {
    let stale = false;
    fetchOptions(insuranceId, () => stale);
    return () => {
      stale = true;
    };
  }, [fetchOptions, insuranceId]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="insurancePlanExternalIdThen"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "insurance_plan_external_id_then")}
      />
    </Grid>
  );
});
